import React from 'react';
import { ResponsiveContainer } from 'recharts';
import { CartesianChartProps } from 'recharts/types/util/types';

import { GraphProps } from '../types.ts';

export const ResponsiveGraphWrapper = ({
  children,
  width,
  height,
}: GraphProps & {
  children: React.ReactElement<CartesianChartProps>;
}) => {
  if (width && height) return React.cloneElement(children, { width, height });

  return (
    <ResponsiveContainer width="100%" height={350}>
      {children}
    </ResponsiveContainer>
  );
};
